import { useEffect } from 'react';

import { modalTypes } from '@/enums';
import { useIsVipEnabled } from '@/hooks/useIsVipEnabled';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { markVipConfirmationSeen } from '@/redux/modules/account/user/user.actions';
import { getHasSeenVipConfirmation } from '@/redux/modules/account/user/user.selectors';
import { openVipConfirmationModal } from '@/redux/modules/modal';
import { getOpenModal } from '@/redux/modules/modal.selectors';

import { VipConfirmationModal } from './VipConfirmationModal';

const VipConfirmationModalTrigger = () => {
    const dispatch = useAppDispatch();
    const hasSeenVipConfirmation = useAppSelector(getHasSeenVipConfirmation);
    const isVipEnabled = useIsVipEnabled();
    const openModal = useAppSelector(getOpenModal);
    const isVipOpen = openModal === modalTypes.VIP_CONFIRMATION;
    const isModalOpen = openModal !== modalTypes.NONE;
    const shouldOpen = isVipEnabled && !isModalOpen && !hasSeenVipConfirmation;

    useEffect(() => {
        if (shouldOpen) {
            dispatch(openVipConfirmationModal());
            dispatch(markVipConfirmationSeen());
        }
    }, [dispatch, shouldOpen]);

    if (!isVipOpen) {
        return null;
    }

    return <VipConfirmationModal />;
};

export default VipConfirmationModalTrigger;
